import React, { Component } from 'react';
import autoBind from 'react-autobind';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import BootstrapTableErrorBoundary from 'src/components/error/BootstrapTableErrorBoundary';

class BusYieldTable extends Component {
    constructor(props) {
        super(props);
        autoBind(this);

        this.selectedRow = [];

        this.state = {
            tableData: this.setTableData(props.companies),
        };
    }

    componentWillReceiveProps(props, state) {
        this.setState({ tableData: this.setTableData(props.companies) });
        if (!props.companySelected) {
            this.selectedRow = [];
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div id="busMapCompanyTable">
                <BootstrapTableErrorBoundary>
                    <BootstrapTable
                        ref={ref => (this.table = ref)}
                        data={this.state.tableData}
                        exportCSV={true}
                        striped={true}
                        hover={true}
                        condensed={true}
                        searchPlaceholder={t('common_phrases.search')}
                        options={{
                            clearSearch: true,
                            onRowClick: this.onSelectRow,
                            exportCSVText: t('common_phrases.export_list'),
                        }}
                        selectRow={{
                            mode: 'radio',
                            hideSelectColumn: true,
                            clickToSelect: true,
                            bgColor: 'rgb(173, 216, 230)',
                            selected: this.selectedRow,
                        }}
                        id="busMapCompanyTable"
                        search={true}>
                        <TableHeaderColumn columnTitle={true} dataField="id" hidden={true} isKey={true} export={true}>
                            {t('common_phrases.id')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="companyName" dataSort={true}>
                            {t('common_phrases.company')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="companyLocation" dataSort={true}>
                            {t('bus.headquarters')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="availableBuses" width="130" dataSort={true}>
                            {t('bus.available_buses')}
                        </TableHeaderColumn>
                        <TableHeaderColumn columnTitle={true} dataField="sumBuses" width="130" dataSort={true}>
                            {t('bus.sum_buses')}
                        </TableHeaderColumn>
                        <TableHeaderColumn
                            dataField="percentageActive"
                            dataAlign="right"
                            width="100"
                            dataFormat={this.percentageFormatter}
                            dataSort={true}>
                            {t('bus.percentage_active')}
                        </TableHeaderColumn>
                    </BootstrapTable>
                </BootstrapTableErrorBoundary>
            </div>
        );
    }

    percentageFormatter(value) {
        let color = '#FF652D';

        if (value === 0) color = 'red';
        else if (value === 100) color = 'green';

        return <span style={{ color: color }}>{value.toFixed(2)} %</span>;
    }

    onSelectRow(company) {
        if (company.id !== this.selectedRow[0]) {
            this.selectedRow = [company.id];
            this.props.onSelectCompany(company.id);
        } else {
            this.selectedRow = [];
            this.props.onSelectCompany(undefined);
        }
    }

    setTableData(companies) {
        const { i18n } = this.props;

        return companies.map(yieldStatistics => {
            const company = yieldStatistics.company;
            return {
                id: company.id,
                companyName: company.companyName,
                companyLocation: company.location.address,
                companyCountry: company.contactData.country,
                totalBuses: yieldStatistics.totalBuses,
                availableBuses: yieldStatistics.availableBuses,
                percentageActive:
                    yieldStatistics.totalBuses === 0
                        ? 0
                        : (yieldStatistics.availableBuses * 100) / yieldStatistics.totalBuses,
                sumBuses: yieldStatistics.totalBuses,
            };
        });
    }

    createCustomToolBar = toolbarProps => {
        const { onToggle, filters, t } = this.props;

        return (
            <div className="col-md-12">
                <div style={{ display: 'flex', marginTop: 10 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 50 }}></div>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            flexGrow: 1,
                            gap: 10,
                        }}>
                        <div style={{ width: 400, marginRight: 6 }}>{toolbarProps.components.searchPanel}</div>
                        <div>{toolbarProps.components.exportCSVBtn}</div>
                    </div>
                </div>
            </div>
        );
    };
}

export default BusYieldTable;
